"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hyperapp = require('./0.12.0/hyperapp');
exports.h = hyperapp.h;
exports.app = hyperapp.app;
//# sourceMappingURL=index.js.map